import styled from "@emotion/styled";

import { useUserAttributes } from "@skilitics/designer-auth/attributes";
import { ContextMenuIconButton, FONT_WEIGHT_SEMI_BOLD, Icon } from "@skilitics/designer-ui-components";

import { UserAccountMenu } from "../../ui/UserAccountMenu";
import { UserAvatar } from "../../ui/UserAvatar";
import { sidebarItemCss } from "./sidebarStyles";

const avatarSize = 32;

const Container = styled.div`
  ${ContextMenuIconButton} {
    width: 100%;
    height: auto;
    padding: 0;
    justify-content: flex-start;
  }
`;

const Trigger = styled.div`
  ${sidebarItemCss}
  width: 100%;
  min-width: 0;
`;

const StyledAvatar = styled(UserAvatar)`
  width: ${avatarSize}px;
  height: ${avatarSize}px;
  border: solid 1px ${({ theme }) => theme.outlineSoft};
  background: ${({ theme }) => theme.primaryContainer};
  flex: 0 0 auto;
`;

const UserName = styled.span`
  font-size: 14px;
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`;

export const UserMenu = () => {
  const user = useUserAttributes();

  if (!user) {
    return null;
  }

  return (
    <Container>
      <UserAccountMenu
        isLandingPage
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        data-test="user-menu-button"
        trigger={
          <Trigger data-test="user-menu">
            <StyledAvatar email={user.email} />
            <UserName>
              {user.given_name} {user.family_name}
            </UserName>
            <Icon icon="angle-down" size={14} />
          </Trigger>
        }
      />
    </Container>
  );
};
